import { type User, type UserLogin } from '@/types';
import { makeRequestActionCreator } from '@/utils';
import { userSlice } from './slice';
import {
  type ResetPasswordPayload,
  type ChangePasswordPayload,
  type UpdateUserRolePayload,
} from './types';

const createRequestAction = makeRequestActionCreator(userSlice.name);

export const login = createRequestAction<UserLogin, User>('login');
export const forgotPassword =
  createRequestAction<Pick<UserLogin, 'email'>>('forgotPassword');
export const resetPassword =
  createRequestAction<ResetPasswordPayload>('resetPassword');
export const logout = createRequestAction('logout');
export const verifyUser = createRequestAction<void, User>('verifyUser');
export const updateUser = createRequestAction<Partial<User>, User>(
  'updateUser',
);
export const changePassword =
  createRequestAction<ChangePasswordPayload>('changePassword');
export const updateUserRole =
  createRequestAction<UpdateUserRolePayload>('updateUserRole');

export const { setUser, clearUser, setUpdatedUser } = userSlice.actions;
